module.exports = __webpack_public_path__ + "static/yenigifler-7b8a6174894600f52e642c5867ea8420.gif";